import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, input } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { EnabledPipe } from "../../../helpers/enabledpipe/enabledpipe";
import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyDdosFilterCommand } from "../../../helpers/self-service/modify_ddos_filter";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";
import { surfcertFilter } from "./selfservice-ddos.helpers";

@Component({
  selector: "selfservice-ddos",
  templateUrl: "selfservice-ddos.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, EnabledPipe, FormsModule, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceDdos {
  protected subscription = input.required<{ ipss: surfcertFilter; subscriptionId: string }>();
  protected bus = input.required<EventEmitter<StartLoadMessage>>();

  protected filterStatus = computed(() => {
    const ipss = this.subscription().ipss;
    if ("surfcertFilterEnabled" in ipss) {
      return ipss.surfcertFilterEnabled;
    } else if ("surfcertFilter" in ipss) {
      return ipss.surfcertFilter === "enabled";
    }
  });

  protected readonly buildCommand = () => {
    const action = SelfServiceCommandKeys.ModifyDdosFilter;
    const modify = new ModifyDdosFilterCommand(!this.filterStatus());
    const command = new SelfServiceCommand(this.subscription().subscriptionId, action);
    command.payload = modify;
    return { command, action };
  };
}
